<script lang="ts">
    import Icon from "@components/material/Icon.svelte"
    import { disableScrollOnPointer } from "@utils/directives/lock-touch-scroll"
    import { fade } from "svelte/transition"

    export let percent: number
    let classList = ""
    export { classList as class }
    export let change: (num: number) => void
    let dragging = false
    let draggableSlider: HTMLDivElement
    export let pulsing = false

    function down(this: HTMLDivElement, evt: PointerEvent) {
        this.setPointerCapture(evt.pointerId)
        dragging = true
    }
    function up(this: HTMLDivElement, evt: PointerEvent) {
        this.releasePointerCapture(evt.pointerId)
        dragging = false
    }
    function out(this: HTMLDivElement, evt: PointerEvent) {
        dragging = false
    }
    function move(this: HTMLDivElement, evt: PointerEvent) {
        if (!dragging) return
        const parent = draggableSlider.offsetParent
        if (!parent) throw new Error("Parent not found!")
        // Get the bounding rectangle of the parent
        const parentRect = parent.getBoundingClientRect()

        // Calculate the touch position within the parent
        // evt.clientX gives the horizontal coordinate within the application's client area
        // parentRect.left gives the left position of the parent relative to the viewport
        const touchPositionInParent = evt.clientX - parentRect.left

        // Calculate the width of the parent
        const parentWidth = parentRect.width

        // Calculate the percentage position of the touch
        const touchPercentage = touchPositionInParent / parentWidth

        // Ensuring the percentage is between 0 and 1
        const clampedPercentage = Math.min(1, Math.max(0, touchPercentage))

        change(clampedPercentage)
    }

    function touchstart(e: TouchEvent) {
        if (dragging) e.preventDefault()
    }
</script>

<svelte:window on:touchstart|nonpassive={touchstart} />
<div
    bind:this={draggableSlider}
    class="origin-center {dragging
        ? 'cursor-grabbing'
        : 'cursor-grab'} w-8 h-8 flex items-center justify-center {classList} rounded-br-full rounded-bl-full rounded-tr-full rotate-45 absolute -translate-x-1/2 bottom-0 translate-y-full {pulsing
        ? 'animate-pulse'
        : ''}"
    style:left="{percent * 100}%"
    on:pointerdown={down}
    on:pointerup={up}
    on:pointercancel={out}
    on:pointermove={move}
>
    <Icon icon="lotus" class="w-5 text-white -translate-y-[1px] -translate-x-[1px] -rotate-45" />
</div>
{#if dragging}
    <div
        style:left="{percent * 100}%"
        class="-top-1 w-max text-sm font-semibold bg-white dark:bg-neutral-800 rounded-lg border-2 dark:border-neutral-600 py-1 px-2 -translate-y-full absolute -translate-x-1/2"
        out:fade={{ duration: 200, delay: 400 }}
        in:fade={{ duration: 100 }}
    >
        <slot />
    </div>
{/if}
